






import Vue from 'vue'
import VueRouter from 'vue-router'
import SubmitAccessCode from './components/screens/SubmitAccessCode.vue'
import Home from './components/screens/Home.vue'
import Permissions from './components/screens/Permissions.vue'
import Seating from './components/screens/Seating.vue'
import ThankYouPage from './components/screens/ThankYouPage.vue'
import StaffScreen from './components/screens/StaffScreen.vue'
import OwnerScreen from './components/screens/OwnerScreen.vue'
import AdminScreen from './components/screens/AdminScreen.vue'
import AdminUsers from './components/screens/AdminUsers.vue'
import NotFound from './components/screens/NotFound.vue'
import BrowserCheck from './components/screens/BrowserCheck.vue'
import PreCheck from './components/screens/PreCheck.vue'
import agora from './services/Agora'
import { Route } from 'vue-router/types/router'
import restaurants from '@/services/Restaurants'
import i18n from '@/services/Translations'
import moment from 'moment'

agora.init()
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      name: 'root',
      path: '/',
      redirect: { name: 'home', params: { lang: 'nl' } },
    },
    {
      name: 'home',
      path: '/:lang',
      component: Home,
      props: true,
      meta: { title: 'global.gastrohome' },
    },
    {
      name: 'browserCheck',
      path: '/:lang/browser-check',
      component: BrowserCheck,
      props: true,
      meta: { title: 'global.gastrohome' },
    },
    {
      name: 'preCheck',
      path: '/:lang/check',
      component: PreCheck,
      props: true,
      meta: { title: 'global.gastrohome' },
    },
    {
      name: 'permissions',
      path: '/:lang/permissions',
      component: Permissions,
      props: true,
      meta: { title: 'global.welcome' },
    },
    {
      name: 'admin',
      path: '/:lang/admin',
      component: AdminScreen,
      meta: { title: 'global.admin' },
    },
    {
      name: 'adminUsers',
      path: '/:lang/admin/users',
      component: AdminUsers,
      meta: { title: 'global.admin' },
    },
    {
      name: 'submitAccessCode',
      path: '/:lang/:restaurantId',
      component: SubmitAccessCode,
      props: true,
      meta: { title: 'global.welcome' },
    },
    {
      name: 'thankyou',
      path: '/:lang/:restaurantId/seating/:accessCode/thank-you',
      component: ThankYouPage,
      props: true,
      meta: { title: 'global.goodBye' },
    },
    {
      name: 'seating',
      path: '/:lang/:restaurantId/seating/:accessCode',
      component: Seating,
      props: true,
      meta: { title: 'global.welcome' },
    },
    {
      name: 'staff',
      path: '/:lang/:restaurantId/staff',
      component: StaffScreen,
      props: true,
      meta: { title: 'global.staff' },
    },
    {
      name: 'owner',
      path: '/:lang/:restaurantId/owner',
      component: OwnerScreen,
      props: true,
      meta: { title: 'global.owner' },
    },
    {
      name: 'ownerStaff',
      path: '/:lang/:restaurantId/owner/staff',
      component: OwnerScreen,
      props: true,
      meta: { title: 'global.owner' },
    },
    {
      name: 'ownerAccessCodes',
      path: '/:lang/:restaurantId/owner/access-codes',
      component: OwnerScreen,
      props: true,
      meta: { title: 'global.owner' },
    },
    {
      name: 'lang404',
      path: '/:lang/**',
      component: NotFound,
      meta: { title: 'global.e404' },
    },
    {
      name: 'global404',
      path: '**',
      redirect: { name: 'lang404', params: { lang: 'nl' } },
    },
  ],
  // @ts-ignore
  scrollBehavior() {
    return { y: 0 }
  },
})

// @ts-ignore
router.beforeEach((to, from, next) => {
  // Check for the language
  const { lang } = to.params
  const supportedLanguages = process.env.VUE_APP_SUPPORTED_LANGS
    ? process.env.VUE_APP_SUPPORTED_LANGS.split('|')
    : ['nl']
  if (!lang || supportedLanguages.indexOf(lang) === -1) {
    const newBaseUrl = router.resolve({ name: 'home', params: { lang: 'nl' } }).href
    next({ path: `${newBaseUrl}${to.path}` })
  }

  // set locale
  i18n.locale = lang
  moment.locale(lang)

  // Set Title and favicon
  setTitle(to)
  setFavicon(to)

  // Start the browser check
  let isChrome = navigator.userAgent.indexOf('Chrome') > -1
  if (isChrome || to.name === 'browserCheck') {
    next()
    return
  }

  const isOpera = !isChrome && navigator.userAgent.indexOf('OP') > -1
  // @ts-ignore
  const isIE = !!document.documentMode
  if (isIE || isOpera) {
    // redirect to "please use Chrome" screen
    next({ name: 'browserCheck', params: { lang } })
    return
  }

  next()
})

function setTitle(to: Route) {
  const metaTitleKey = to.meta?.title
  const metaTitle = i18n.t(metaTitleKey) as string
  const restaurantId = to.params?.restaurantId

  if (metaTitle && restaurantId) {
    document.title = metaTitle.replace('[x]', restaurantId)
    return
  }

  document.title = metaTitle || 'Gastrohome'
}

async function setFavicon(to: Route) {
  const restaurantId = to.params?.restaurantId
  const favicon = document.getElementById('favicon') as HTMLLinkElement

  if (!restaurantId) {
    // show Gastrohome, which is the default
    return
  }

  const restaurant = await restaurants.getPublicRestaurant(restaurantId)
  if (!restaurant) {
    return
  }

  const faviconSize = 128
  const canvas = document.createElement('canvas')
  canvas.width = faviconSize
  canvas.height = faviconSize

  const context = canvas.getContext('2d')
  if (!favicon || !context) {
    return
  }

  const img = document.createElement('img')
  img.crossOrigin = 'Anonymous'
  img.src = restaurant.logoSmallUrl

  img.onload = () => {
    // Draw Original Favicon as Background
    context.drawImage(img, 0, 0, faviconSize, faviconSize)

    // Replace favicon
    favicon.href = canvas.toDataURL('image/png')
  }
}

export default Vue.extend({
  name: 'app',
  methods: {},
  components: {
    SubmitAccessCode,
    Seating,
    Permissions,
  },
  router,
})
